export default __webpack_public_path__ + "static/media/phone-call.2d15b648.svg";